import React from "react";
import CustomizerWidget from "@widget/components/CustomizerWidget";

export default function App() {
    return (
        <CustomizerWidget/>
    );
}
